import Vue from 'vue'
import { IS_LOADING, IS_SAVING } from '../constants.js'
import {
	REDUCER_NAME,
	IS_SAVING_FILE_DATA,
	SELL_INQUIRY_FORM_DATA,
	SELL_INQUIRY_FORM_FILE_DATA,
	SET_IS_LOADING_SELL_INQUIRY_FORM_DATA,
	SET_SELL_INQUIRY_FORM_FILE_DATA,
	SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA,
	SET_SELL_INQUIRY_FORM_RESPONSE_DATA,
	SET_IS_SAVING_SELL_INQUIRY_FORM_DATA,
	SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA,
	SET_SELL_INQUIRY_FORM_DATA
} from './constants.js'

const setIsLoadingSellInquiryFormData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[IS_LOADING]: payload
	})
}

const setIsSavingSellInquiryFormData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[IS_SAVING]: payload
	})
}

const setIsSavingSellInquiryFileData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[IS_SAVING_FILE_DATA]: payload
	})
}

const setSellInquiryFormData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[SELL_INQUIRY_FORM_DATA]: payload
	})
}

const setSellInquiryFormFileData = function (state, payload) {
	Vue.set(state, REDUCER_NAME, {
		...state[REDUCER_NAME],
		[SELL_INQUIRY_FORM_FILE_DATA]: payload
	})
}

const mutations = {
	[SET_IS_LOADING_SELL_INQUIRY_FORM_DATA] (state, payload) {
		setIsLoadingSellInquiryFormData(state, payload)
	},
	[SET_SELL_INQUIRY_FORM_DATA] (state, payload) {
		setSellInquiryFormData(state, payload)
	},
	[SET_IS_SAVING_SELL_INQUIRY_FORM_DATA] (state, payload) {
		setIsSavingSellInquiryFormData(state, payload)
	},
	[SET_SELL_INQUIRY_FORM_FILE_DATA] (state, payload) {
		setSellInquiryFormFileData(state, payload)
	},
	[SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA] (state, payload) {
		setIsSavingSellInquiryFileData(state, payload)
	},
	[SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA] (state, payload) {
		setSellInquiryFormFileData(state, payload)
	},
	[SET_SELL_INQUIRY_FORM_RESPONSE_DATA] (state, payload) {
		setSellInquiryFormData(state, payload)
	}
}

export {
	mutations
}
